import about from './data/about';
import benefits from './data/benefits';
import communication from './data/communication';
import it from './data/it';
import navigation from './data/navigation';
import other from './data/other';
import pay from './data/pay';
import software from './data/software';

export default {
	about: about,
	benefits: benefits,
	communication: communication,
	it: it,
	navigation: navigation,
	other: other,
	pay: pay,
	software: software
};



// WEBPACK FOOTER //
// ./src/components/Icon/data.js